/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment } from 'react'
import { Table, Divider, Tooltip, Icon } from 'antd'
import styles from './index.less'
import moment from 'moment'
import { DRUG } from '@/utils/consts'

const OrderTable = ({ data, type, onEdit, payments, status, source, paymentPagination, onPaymentPageNoChange, onPaymentDelete, onReceivablesEdit }) => {
  const columns = [
    {
      key: 'productCategoryName',
      title: '商品类别',
      width: 120,
      ellipsis: true,
      render: (_, record) => (record.categoryList || []).map(_ => _.name).join('/')
    },
    {
      dataIndex: 'name',
      title: '商品名称',
      ellipsis: true,
      width: 120,
    },
    {
      key: 'serviceDuration',
      title: '服务时长',
      width: 70,
      align: 'right',
      render: (_, record) => {
        if (!record.product) return null;

        const { serviceDuration, unit } = record.product;

        return (serviceDuration || '') + (unit || '');
      }
    },
    {
      key: 'serviceQuantity',
      title: '服务频次',
      width: 70,
      align: 'right',
      render: (_, record) => (record.product || {}).quantity
    },
    {
      dataIndex: 'price',
      title: '商品定价',
      width: 70,
      render: price => price > 0 ? price + '元' : price,
      align: 'right'
    },
    {
      dataIndex: 'quantity',
      title: '数量',
      width: 60,
      align: 'right'
    },
    {
      dataIndex: 'discount',
      title: '折扣',
      width: 60,
      align: 'right',
      render(discount) {
        return parseInt(discount <= 1 ? discount * 100 : discount) + '%'
      }
    },
    {
      dataIndex: 'discountPrice',
      title: '折后金额',
      width: 80,
      align: 'right',
      render: (discountPrice) => discountPrice > 0 ? discountPrice + '元' : undefined
    },
    // {
    //   dataIndex: 'couponPrice',
    //   title: '单项立减',
    //   width: 80,
    //   align: 'right',
    //   render: couponPrice => couponPrice > 0 ? couponPrice + '元' : couponPrice
    // },
    {
      title: '折后立减',
      dataIndex: 'couponPrice',
      width: 100,
      align: 'right',
      render: (amount) => amount > 0 ? amount + '元' : '0.00元'
    },
    {
      dataIndex: 'actualAmount',
      title: '单项收款',
      width: 100,
      align: 'right',
      render: (amount, record) => {

        return <Fragment>
          {amount > 0 ? amount + '元' : amount}
          {/* <Tooltip title={`折扣：${parseInt(record.discount <= 1 ? record.discount * 100 : record.discount) + '%'}\n折后金额：${record.discountPrice > 0 ? (record.discountPrice * record.quantity) + '元' : record.discountPrice}\n单项立减：${record.couponPrice > 0 ? record.couponPrice + '元' : record.couponPrice}`}><Icon type="question-circle" theme="twoTone" /></Tooltip> */}
        </Fragment>
      }
    },

    {
      dataIndex: 'realAmount',
      title: '分摊实收明细',
      width: 80,
      align: 'right',
      render: (amount, record) => {

        return <Fragment>
          {amount > 0 ? amount + '元' : amount}

        </Fragment>
      }
    },
    {
      title: '总服务次数',
      dataIndex: 'totalCount',
      width: 100,
      align: 'right',
    },
    {
      title: '已消耗次数',
      dataIndex: 'consumptionCount',
      width: 100,
      align: 'right',
    },
    {
      title: '已退款次数',
      dataIndex: 'refundOrderItems',
      width: 80,
      align: 'right',
      render(text, record) {
        let refundQuantity = 0
        if (record.refundOrderItems && record.refundOrderItems.length) {
          refundQuantity = record.refundOrderItems.reduce((prev, current, index) => {
            const { refundQuantity } = current;
            prev = prev + refundQuantity;
            return prev;
          }, 0);
        }
        // console.log(refundQuantity)
        return refundQuantity
      }
    },
    {
      title: '已消耗金额',
      dataIndex: 'consumptionAmount',
      width: 100,
      align: 'right',
      render: (amount) => amount >= 0 ? amount.toFixed(2) + '元' : undefined
    },
    {
      dataIndex: 'comment',
      title: '备注',
      width: 120,
      ellipsis: true,
    },
  ]

  const colums2 = [
    {
      title: '药品名称',
      dataIndex: 'name',
      ellipsis: true,
    },
    {
      title: '规格',
      dataIndex: 'specification',
      width: 120,
      render(text, record) {
        return record.drug && record.drug.specification
      }
    },
    {
      title: '单次剂量（单位）',
      dataIndex: 'dosage',
      width: 120,
      render(text, record) {
        return `${text}/${record.dosageUnit}`
      }
    },
    {
      title: '频次',
      dataIndex: 'frequency',
      width: 120,
    },
    {
      title: '用法',
      dataIndex: 'usage',
      width: 100,
    },
    {
      dataIndex: 'treatmentDays',
      title: '疗程',
      width: 100,
      render(treatmentDays, record, index) {
        return treatmentDays && (DRUG.treatmentDays.filter(_ => _.value === treatmentDays)[0] || {}).lable
      }
    },
    {
      title: '数量',
      dataIndex: 'quantity',
      width: 100,
    },
    {
      title: '医嘱备注',
      dataIndex: 'comment',
      width: 120,
      ellipsis: true,
    },
    // {
    //   title: '折扣',
    //   dataIndex: 'discount',
    //   width: 120,
    //   align: 'right',
    //   render: discount => discount <= 1 ? Number(discount * 100).toFixed(2) + '%' : undefined
    // },
    // {
    //   title: '折后金额',
    //   dataIndex: 'discountPrice',
    //   width: 120,
    //   align: 'right',
    //   render: (discountPrice) => discountPrice > 0 ? discountPrice + '元' : undefined
    // },
    // {
    //   title: '实收金额',
    //   dataIndex: 'actualAmount',
    //   width: 120,
    //   align: 'right',
    //   render: (amount) => amount > 0 ? amount + '元' : undefined
    // },
  ]

  // const receivablesColumns = [
  //   {
  //     dataIndex: 'receiptDate',
  //     title: '收款日期',
  //     width: 120,
  //     render(text) {
  //       return moment(text).format('YYYY-MM-DD')
  //     }
  //   },
  //   {
  //     dataIndex: 'payMethod',
  //     title: '付费习惯',
  //     width: 100,
  //     render: payMethod => PAY_METHOD_MAP[payMethod]
  //   },
  //   {
  //     dataIndex: 'paymentMethod',
  //     title: '支付方式',
  //     width: 100,
  //     render: paymentMethod => PAYMENT_METHOD_MAP[paymentMethod]
  //   },
  //   {
  //     dataIndex: 'amount',
  //     title: '本次收款金额',
  //     align: 'right',
  //     width: 120,
  //     render: (amount) => amount + "元"
  //   },
  //   {
  //     dataIndex: 'financialConfirmer',
  //     title: '财务确认人',
  //     width: 100,
  //     align: 'center',
  //   },
  //   {
  //     dataIndex: 'comment',
  //     title: '备注',
  //     ellipsis: true,
  //   },
  //   {
  //     dataIndex: 'operation',
  //     title: '操作',
  //     width: 120,
  //     align: 'center',
  //     render(text, record) {
  //       if ([ORDER_STATUS_TO_PAY, ORDER_STATUS_PART_PAY, ORDER_STATUS_PAID].indexOf(status) === -1) return null;
  //       if (source === 'task') return null
  //       return (
  //         <Fragment>
  //           <a href="javascript:void(0);" onClick={() => onReceivablesEdit('update', record)}>编辑</a>
  //           {/**
  //           <Divider type='vertical' />
  //           <Popconfirm title='确认删除此收费信息吗？' onConfirm={() => onDelete(record)}>
  //             <a href="javascript:void(0);">删除</a>
  //           </Popconfirm>
  //            */}
  //         </Fragment>
  //       );
  //     }
  //   }
  // ]

  return (
    <div className={styles.follow}>
      <Table
        columns={type === 'drug' ? colums2 : columns}
        dataSource={data}
        pagination={false}
        scroll={{ x: 1000 }}
        size="small"
        rowKey="id"
      />

      {/* <Table
        columns={receivablesColumns}
        dataSource={payments}
        pagination={{
          ...paymentPagination,
          onPaymentPageNoChange
        }}
        size="small"
        rowKey="id"
        style={{marginTop: 10}}
      /> */}
    </div>
  )
}

export default OrderTable
